import { IMVKSectionInfo } from '../../types/newbuilding/mvk';
import { IApplicationState } from '../../types/redux';

export const getServerMvkData = (state: IApplicationState): IMVKSectionInfo[] => {
  return state.newbuilding.mvkData.sections;
};
